import * as React from 'react';
import { memo } from 'react';

import { Link } from 'react-router-dom';

import routes from 'defs/routes';
import noop from 'helper/noop';

export type ProgramFilterItem = {
	id: string;
	label: string;
	count: number;
	selected?: boolean;
};

export type ProgramFilterProps = {
	selected?: string;
	filters: ProgramFilterItem[];
	filterSignature?: string;
};

export class ProgramFilter extends React.Component<ProgramFilterProps> {
	public static displayName = 'ProgramFilter';

	public static defaultProps = {
		onFilterChange: noop,
		filters: [],
	};

	public renderProgramFilterItem(item: ProgramFilterItem) {
		const classes = ['m-program-filter__link'];

		if (this.props.selected === item.id) {
			classes.push('state-m-program-filter__link--selected');
		}

		return (
			<li key={item.id} className="m-program-filter__item">
				<Link className={classes.join(' ')} to={`${routes.program[item.id || 'recommended'].href}`}>
					{item.label}&nbsp;({item.count})
				</Link>
			</li>
		);
	}

	public render() {
		const _this = this;
		const { filters } = this.props;

		return (
			<div className="m-program-filter">
				<ul className="m-program-filter__list">{filters.map(this.renderProgramFilterItem.bind(_this))}</ul>
			</div>
		);
	}
}

export default memo(ProgramFilter, (prevProps, nextProps) => {
	return (
		prevProps.selected === nextProps.selected &&
		prevProps.filterSignature === nextProps.filterSignature &&
		prevProps.filters === nextProps.filters
	);
});
